<template>
  <div id="mappage">
    <div class="container-fluid">
      <div class="row main-content">
        <div class="col-md-12 map-container" data-aos="fade-up">
          <img src="./../../assets/imgs/home_foto5.png">
        </div>
        <div class="col-md-5 cornered" data-aos="fade-right">
          <div class="info-container">
            <h4 class="small-title" v-html="state.title">
              <hr>
            </h4>
            <h1>{{state.subTitle}}</h1>
            <br>
            <p style="width:300px; font-size:15pt;">{{state.pTextTop}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  methods: {
  },
  components: {
  },
  computed: {
    state() {
      return this.$store.state.activeList.mapHome
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';


.main-content {
  display: block;
  color: $gris;
}

.map-container {
  margin-top: -200px;
  margin-bottom: -200px;
}

hr {
  display: inline-block;
  vertical-align: middle;
  height: 2px;
  border: 0;
  width: 20%;
  border-top: 2px solid $azul;
  margin: 1em 1em;
  padding: 0;
}

h1 {
  color: white;
  font-size: 40pt;
}

img {
  width: 100%;
}

.text-container {
  text-align: left;
  margin-top: 5%;
}

.small-title {
  width: 100%;
  text-align: left;
  vertical-align: middle;
}



.info-container {
  color: white;
  text-align: left;
  position: absolute;
  padding: 40px;
}

.cornered {
  width: 40%;
  box-sizing: border-box;
  border-bottom: 30em solid $rojo;
  border-right: 7em solid transparent;
}

@media screen and (max-width:1261px) {
  .map-container {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .col-md-5 {
    padding: 0px;
  }

  .info-container {
    color: white;
    text-align: left;
    position: relative;
    padding: 40px;
    background-color: $rojo;
  }


  h4 {
    font-size: 16px;
  }

  .cornered {
    width: 100%;
    box-sizing: none;
    border-bottom: 0em solid $rojo;
    border-right: 0em solid transparent;
  }
}
</style>



// WEBPACK FOOTER //
// MapPage.vue?6a44a526